import(/* webpackMode: "eager", webpackExports: ["VaultClient"] */ "/codebuild/output/src88813650/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/vaults/[id]/VaultClient.tsx");
